/**
 * Words only: the homepage hero (HomepageHero) owns the proof marks, and
 * repeating them further down the page weakens both.
 */
export const WhoYoureBuyingFrom = () => (
    <section className="w-full bg-white px-[22px] py-[34px] md:px-10 md:py-14">
        <div className="mx-auto max-w-[1120px]">
            <h2 className="text-center text-[23px] font-bold leading-[1.22] text-[#343434] md:text-[28px]">
                Who You&apos;re Buying From and Selling To
            </h2>

            <div className="mt-[18px] md:mt-[26px] md:grid md:grid-cols-[340px_minmax(0,1fr)] md:items-start md:gap-11">
                <img
                    src="/images/static/firearmland-shop-inspection.webp"
                    alt="FirearmLand staff inspecting a rifle at the workbench in the Jacksonville shop"
                    loading="lazy"
                    width="340"
                    height="227"
                    className="mx-auto block h-auto w-full max-w-[280px] md:mx-0 md:max-w-[340px]"
                />

                <div className="mt-[22px] max-w-[70ch] text-[16.5px] leading-[1.65] text-[#485460] md:mt-0">
                    <p>
                        FirearmLand started as a small shop in Jacksonville,
                        Florida. We&apos;re federally licensed and a Class 3
                        dealer, and we&apos;ve bought and sold firearms for
                        thousands of owners since.
                    </p>
                    <p className="mt-4">
                        <strong className="font-bold text-[#343434]">
                            We deal plainly.
                        </strong>{" "}
                        Our listing photos are never retouched. What you see is
                        what you get, and that cuts both ways when we&apos;re
                        the ones making you an offer.
                    </p>
                    <p className="mt-4">
                        <strong className="font-bold text-[#343434]">
                            You get a person.
                        </strong>{" "}
                        Questions reach a human being on whichever channel you
                        prefer, not a ticket queue.
                    </p>
                    <p className="mt-4">
                        <strong className="font-bold text-[#343434]">
                            One legal transaction.
                        </strong>{" "}
                        We handle the compliance end to end. No meeting a
                        stranger from the internet, no paperwork you have to
                        figure out.
                    </p>
                </div>
            </div>
        </div>
    </section>
)
